import React from 'react'
import { observer } from 'mobx-react'
import { SideSheetHostView, SideSheetMain } from '../../components/SideSheet'
import {
  Sandwich,
  SandwichBun,
  SandwichContent,
} from '../../components/Sandwich'
import {
  StickyViewHeader,
  StickyViewHeaderExtras,
  StickyViewHeaderMain,
  StickyViewHeaderSpacer,
} from '../../components/StickyViewHeader'
import { ViewHeading } from '../../components/ViewHeading'
import { ContentLayout, ContentMain } from '../../components/ContentLayout'
import { FrameValue } from 'react-spring'
import { useScrollOffsetSpring } from '../../hooks/spring-hooks'
import ListHeader from '../../components/ListHeader'
import { MergeRequestsTable } from './MergeRequestsTable'
import { AccountMergeRequestsViewModel } from './AccountMergeRequestsViewModel'
import { AccountMergeRequestFilterOption } from './AccountMergeRequestSearchViewModel'
import {
  RadioButtonGroup,
  RadioButtonItem,
} from '../../components/RadioButtonGroup'
import { useActivation } from '../../hooks/mobx-hooks'

interface Props {
  vm: AccountMergeRequestsViewModel
}

export default observer(function MergeAccountsScreen({ vm }: Props) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)

  useActivation(vm)

  return (
    <>
      <SideSheetHostView>
        <SideSheetMain>
          <Sandwich stretch>
            <SandwichBun>
              <MergeAccountsHeader scrollOffset={scrollOffset}>
                <RadioButtonGroup size="medium">
                  <RadioButtonItem
                    active={
                      vm.searchViewModel.filterOption ===
                      AccountMergeRequestFilterOption.Pending
                    }
                    onClick={() =>
                      vm.searchViewModel.setFilterOption(
                        AccountMergeRequestFilterOption.Pending,
                      )
                    }
                  >
                    Pending
                  </RadioButtonItem>
                  <RadioButtonItem
                    active={
                      vm.searchViewModel.filterOption ===
                      AccountMergeRequestFilterOption.Processed
                    }
                    onClick={() =>
                      vm.searchViewModel.setFilterOption(
                        AccountMergeRequestFilterOption.Processed,
                      )
                    }
                  >
                    Processed
                  </RadioButtonItem>
                </RadioButtonGroup>
              </MergeAccountsHeader>
            </SandwichBun>
            <SandwichContent stretch>
              <ContentLayout
                accountForLabel
                accountForTabBar
                fill
                ref={scrollRef}
              >
                <ContentMain fill constrainWidth>
                  <Sandwich stretch>
                    <SandwichBun>
                      <ListHeader count={vm.total}>Requests</ListHeader>
                    </SandwichBun>
                    <SandwichContent>
                      <MergeRequestsTable vm={vm} />
                    </SandwichContent>
                  </Sandwich>
                </ContentMain>
              </ContentLayout>
            </SandwichContent>
          </Sandwich>
        </SideSheetMain>
      </SideSheetHostView>
    </>
  )
})

interface MergeAccountsHeaderProps {
  scrollOffset: FrameValue<number>
  children?: React.ReactNode
}

function MergeAccountsHeader({
  children,
  scrollOffset,
}: MergeAccountsHeaderProps) {
  return (
    <>
      <StickyViewHeader bordered scrollOffset={scrollOffset}>
        <StickyViewHeaderMain>
          <ViewHeading
            primaryText="Merge Accounts"
            secondaryText="All workspaces"
          />
        </StickyViewHeaderMain>
        <StickyViewHeaderSpacer />
        <StickyViewHeaderExtras>{children}</StickyViewHeaderExtras>
      </StickyViewHeader>
    </>
  )
}
